class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.sliderElement = this.querySelector('[data-slider]');
    this.slider = null;

    this.header = document.querySelector('.section--header');
    this.announcementBar = this;

    this.isBelow = this.announcementBar?.classList.contains('announcement-bar--is-bellow') || false;

    window.addEventListener('resize', debounce(this.initSlider.bind(this), 100));
  }

  connectedCallback() {
    this.initSlider();
    if(!this.header.classList.contains('header--transparent') && this.isBelow) {
      const headerHeight = this.header.offsetHeight;
      this.setOffset(headerHeight);
    }
  }

  initSlider() {
    const sliderElement = this.querySelector('.announcement-bar__inner');

    if (!sliderElement) return;

    if (window.innerWidth >= 990 && sliderElement.hasAttribute('data-slider-destroy-desktop')) {
      sliderElement.classList.add('is-initialized');
      return;
    }

    if (this.slider !== null) return;

    this.slider = new Swiper(sliderElement, {
      direction: 'horizontal',
      loop: true,
      autoplay: {
        delay: Number(this.sliderElement.dataset.interval),
        disableOnInteraction: false,
      },
      simulateTouch: false
    });
  }

  setOffset(headerHeight) {
    if (!this.announcementBar) return;

    const announcementBarSection = this.announcementBar.closest('.section--announcement-bar');
    announcementBarSection.classList.add('announcement-bar--float');
    const offset = 10;
    announcementBarSection.style.top = `${offset}px`;
  }

  adjustParentPadding(header) {
    if (!this.announcementBar) return;

    const isBelow = this.isBelow;
    const paddingProperty = isBelow ? 'paddingTop' : 'paddingBottom';
    this.announcementBar.parentElement.style[paddingProperty] = `${header.offsetHeight}px`;
  }

  resetParentPadding() {
    if (!this.announcementBar) return;

    const isBelow = this.isBelow;
    const paddingProperty = isBelow ? 'paddingTop' : 'paddingBottom';
    this.announcementBar.parentElement.style[paddingProperty] = '0px';
  }

  isBelowHeader() {
    return this.isBelow;
  }
}

customElements.define('announcement-bar', AnnouncementBar);
